import axios from 'axios'

import { API_BASE_URL, FRONT_BASE_URL, KEY } from '@/constants'

const axiosServer = axios.create({ baseURL: API_BASE_URL })
const axiosClient = axios.create({ baseURL: FRONT_BASE_URL })

// Istanza autenticata per Gravity Forms
const gravityToken = `${KEY.GF_CONSUMER_KEY}:${KEY.GF_CONSUMER_SECRET}`
const encodedGravityToken = Buffer.from(gravityToken).toString('base64')
const axiosGravity = axios.create({
  baseURL: API_BASE_URL,
  headers: { Authorization: `Basic ${encodedGravityToken}` }
})

axiosClient.defaults.headers.common['Env'] =
  process.env.NODE_ENV === 'development' ? 'development' : 'production'

export { axiosClient, axiosGravity, axiosServer }
